/* storybook-check-ignore */
import { Flex } from '@opendoor/bricks/core';

const DiscountIcon = ({ size = 33 }: { size?: number }) => {
  return (
    <Flex
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      justifyContent="center"
      alignItems="center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g opacity="0.8">
          <path
            d="M8.43234 0.782586C8.65054 0.56438 8.95727 0.459139 9.26348 0.497415L13.6633 1.04739C14.1172 1.10413 14.4748 1.46169 14.5315 1.91563L15.0815 6.31541C15.1197 6.62161 15.0145 6.92834 14.7963 7.14655L6.65685 15.286C6.26633 15.6765 5.63316 15.6765 5.24264 15.286L0.292893 10.3362C-0.0976311 9.94572 -0.097631 9.31256 0.292893 8.92203L8.43234 0.782586Z"
            fill="#082DE6"
          />
          <circle cx="11.3174" cy="4.10242" r="1.13507" fill="white" />
        </g>
      </svg>
    </Flex>
  );
};

export default DiscountIcon;
